module.exports = __webpack_public_path__ + "static/img/weixin_findpwd.854bbaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-4/weixin_findpwd.jpg
// module id = kZYJ
// module chunks = 1